// Router + guard do app CRM | CS.
//
// O guard reusa as MESMAS primitivas do Hub (authStore, userAccessMap,
// resolveUserRouteAccessLevel) para a semântica de permissão não derivar:
// rota fora do mapa é NEGADA (fail-secure), 'none' é negado, admin master
// passa. Sem o delay de 1s do Hub (era UX do shell clássico).
import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';
import { useTenantStore } from '@/stores/tenantStore';
import { resolveUserRouteAccessLevel } from '@/utils/userRouteAccess';
import { deveRevalidar } from '../composables/revalidacao';
import { crmRoutes } from './routes';

const router = createRouter({
  // NUNCA createWebHistory('/crm/cs') — produziria cs.…/crm/cs/medicoes.
  history: createWebHistory('/'),
  routes: crmRoutes,
});

/** Quando o mapa de rotas foi buscado — a régua de revalidação lê daqui. */
let rotasBuscadasEm = 0;

router.beforeEach(async (to) => {
  const auth = useAuthStore();

  if (to.meta.requiresAuth === false) {
    return true;
  }

  await auth.initializeAuth();
  if (!auth.isAuthenticated) {
    return { path: '/login', query: { redirect: to.fullPath } };
  }

  // Módulo desligado no tenant → nada a mostrar.
  const tenant = useTenantStore();
  if (tenant.enabledModules.length > 0 && !tenant.enabledModules.includes('crm-cs')) {
    return { path: '/login', query: { error: 'modulo_desligado' } };
  }

  // ⚠ Reconfere o mapa de ROTAS do Hub quando ele está velho — ele também era
  // buscado uma vez por sessão de página, então conceder a rota a alguém só
  // fazia efeito depois de sair e entrar (relatado em 17/08/2026). Aqui a
  // navegação é o gatilho natural: quem foi avisado "te dei acesso" clica no
  // menu, e é nesse clique que o mapa novo chega.
  await auth.fetchUserRouteLevelPaths();
  if (deveRevalidar({ buscadoEm: rotasBuscadasEm, buscando: false }, Date.now())) {
    rotasBuscadasEm = Date.now();
    // `force` refaz o GET; sem await para a navegação atual não esperar pela
    // rede — quem decide ESTE clique é o mapa que já está em memória, e o
    // próximo já usa o novo. Falha silenciosa: o mapa antigo continua valendo.
    void auth.fetchUserRouteLevelPaths(true).catch(() => {});
  } else if (!rotasBuscadasEm) {
    rotasBuscadasEm = Date.now();
  }

  if (auth.user?.isAdminMaster) {
    return true;
  }

  const permissionPath = String(to.meta.permissionPath || '');
  if (!permissionPath) return true; // rota sem chave (404 etc.)

  const level = resolveUserRouteAccessLevel(permissionPath, auth.userAccessMap);
  if (!level || level === 'none') {
    // Fail-secure. Sem acesso à carteira também → tela de login com aviso.
    if (permissionPath !== '/crm/cs') return { path: '/' };
    return { path: '/login', query: { error: 'sem_acesso' } };
  }
  return true;
});

export default router;
